export const dashboardMetricsConstants = {
  GET_DASHBOARD_METRICS_REQUEST: 'GET_DASHBOARD_METRICS_REQUEST',
  GET_DASHBOARD_METRICS_SUCCESS: 'GET_DASHBOARD_METRICS_SUCCESS',
  GET_DASHBOARD_METRICS_FAILURE: 'GET_DASHBOARD_METRICS_FAILURE',
};
